/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_FineprintInputs */

const en_funnel_ob_welcome_fineprint = /** @type {(inputs: Funnel_Ob_Welcome_FineprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined by 50,000+ students & researchers`)
};

const es_funnel_ob_welcome_fineprint = /** @type {(inputs: Funnel_Ob_Welcome_FineprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se han unido más de 50.000 estudiantes e investigadores`)
};

/**
* | output |
* | --- |
* | "Joined by 50,000+ students & researchers" |
*
* @param {Funnel_Ob_Welcome_FineprintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_fineprint = /** @type {((inputs?: Funnel_Ob_Welcome_FineprintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_FineprintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_fineprint(inputs)
	return en_funnel_ob_welcome_fineprint(inputs)
});